import React, {useState} from 'react';
import Calendar from 'react-calendar';
import s from './MediaAndNews.module.css';
import {format} from 'date-fns';
import {uk} from 'date-fns/locale';
import {useFormikContext, FormikContextType} from 'formik';
import {dateFormatter} from '../../assets/utils/dateUtils';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

type Props = {
	close: (b: boolean) => void;
	setCurrentMonthName: (value: string) => void;
	setAmountOfMonth?: (value: number) => void;
	setCurrentMonth?: (value: string) => void;
	wrapperClassName?: string;
	calendarClassName?: string;
};

const ChangeMonthCalendar: React.FC<Props> = ({
	close,
	setCurrentMonthName,
	setAmountOfMonth,
	setCurrentMonth,
	wrapperClassName,
	calendarClassName,
}) => {
	const [value, onChangeValue] = useState<Value>(new Date());

	// пробуем достать Formik-контекст, если он есть

	// хук всегда вызываем
	const formik = useFormikContext<any>() as FormikContextType<any> | null;

	const handleChange = (newValue: any) => {
		const dateObject = new Date(newValue);
		const year = dateObject.getFullYear();
		const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
		const fullMonthName = dateObject.toLocaleString('uk-UA', {month: 'long'});

		setCurrentMonthName(`${fullMonthName} ${year}`);
		onChangeValue(newValue);

		if (setAmountOfMonth) {
			const daysCalc = new Date(year, +month, 0).getDate();
			setAmountOfMonth(daysCalc);
		}

		// Формируем дату первого дня месяца для фильтрации
		const firstDayOfMonth = `${year}-${month}-01`;

		// если Formik есть — пишем в форму
		formik?.setFieldValue('month', firstDayOfMonth);
		if (setCurrentMonth) {
			setCurrentMonth(firstDayOfMonth);
		}
		close(false);
	};

	const formatMonthYear = (date: any) =>
		format(date, 'LLLL yyyy', {locale: uk});

	const calendarClassNames = [s.calendarContainer, calendarClassName]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={wrapperClassName}>
			<Calendar
				view="year"
				tileClassName={s.calendarTile}
				locale="uk-UA"
				formatMonthYear={(_, date) => formatMonthYear(date)}
				className={calendarClassNames}
				onClickMonth={handleChange}
				onChange={handleChange}
				value={value}
			/>
		</div>
	);
};

export default ChangeMonthCalendar;
